import { render } from "./App.vue?vue&type=template&id=77b1042f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=77b1042f&lang=scss"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__